export const WebServicesIndustryTabsData = {
    webDevPageIndustryContent: {
        defaultTabOpen: "Healthcare"
    },

    WebServicesIndustryTabsData: [
        "Healthcare",
        // "Fintech",
        "E-commerce & Retail",
        "Real Estate",
        "Automotive",
        "Education",
        "Insurance",
        "Logistics",
        "Entertainment",
        "Gaming",
        // "Social Networking",
        // "Telecom",
        // "Energy",
    ],

    WebServicesIndustryTabsItemsData: [
        {
            tabName: "Healthcare",
            tabDes:
                "We’re helping transform the healthcare sector with web applications that make patient care simpler & more efficient. Whether it’s managing patient records securely, enabling telehealth consultations, or improving operations, our solutions are tailored to meet the needs of healthcare providers & their patients.",
            objectives: [
                "Manage patient data safely & easily.",
                "Create accessible telehealth platforms.",
                "Enhance healthcare services with innovative tools.",
            ],
            href: "/industries/healthcare",
            tabImage: "health-care-image.png",
        },
        {
            tabName: "Fintech",
            tabDes:
                "Fintech thrives on innovation, & we’re here to drive it forward. Our web apps simplify complex financial processes, from secure payment systems to financial planning tools. They’re designed to empower businesses, enhance customer experiences, & keep everything secure along the way.",
            objectives: [
                "Simplify secure financial transactions.",
                "Build scalable platforms for growing businesses.",
                "Improve customer satisfaction with intuitive designs.",
            ],
            href: "/industries/fintech",
            tabImage: "Fintech.png"
        },
        {
            tabName: "E-commerce & Retail",
            tabDes:
                "Shopping online should be seamless, & our web apps make sure it is. From personalized shopping experiences to advanced inventory management, we help businesses connect with customers, grow their sales, & create lasting impressions.",
            objectives: [
                "Create dynamic shopping platforms.",
                "Stay on top of inventory & orders in real-time.",
                "Engage customers with personalized features",
            ],
            href: "/industries/retail-ecommerce",
            tabImage: "Retail-ecommerce.png"
        },
        {
            tabName: "Real Estate",
            tabDes:
                "Finding & managing properties has never been easier. With our web apps, you can offer virtual tours, manage client relationships, & help buyers & sellers connect seamlessly. We build tools that keep real estate professionals one step ahead.",
            objectives: [
                "Showcase properties with virtual tours.",
                "Simplify property searches with user-friendly tools.",
                "Strengthen client relationships with easy-to-use platforms.",
            ],
            href: "/industries/real-estate",
            tabImage: "Realestate.png"
        },
        {
            tabName: "Automotive",
            tabDes:
                "The automotive industry is moving fast, & our web apps keep pace. Whether it’s tracking vehicles, managing inventory, or engaging with customers, we create solutions that streamline operations & improve the overall experience.",
            objectives: [
                "Keep track of vehicles with advanced systems.",
                "Manage inventory & services efficiently.",
                "Enhance customer experiences with smart tools.",
            ],
            href: "/industries/automotive",
            tabImage: "automotive.png"
        },
        {
            tabName: "Education",
            tabDes:
                "Education should be engaging & accessible, & our web apps make it happen. From e-learning platforms to tools for managing classrooms, we design solutions that cater to students, educators, & institutions, bringing everyone closer to success.",
            objectives: [
                "Build interactive & engaging e-learning tools.",
                "Simplify administrative tasks for institutions.",
                "Personalize the learning experience for students.",
            ],
            href: "/industries/education",
            tabImage: "education.png"
        },
        {
            tabName: "Insurance",
            tabDes:
                "We make insurance processes smooth & hassle-free. Our web apps simplify claims, manage policies, & improve communication with customers. These secure & efficient solutions are built to adapt to the ever-changing needs of the insurance sector.",
            objectives: [
                "Simplify claims management & tracking.",
                "Handle sensitive policy data securely.",
                "Improve customer engagement with better tools.",
            ],
            href: "/industries/insurance",
            tabImage: "Insurance.png"
        },
        {
            tabName: "Logistics",
            tabDes:
                "Efficiency is the backbone of logistics, & we’re here to deliver it. Our web apps streamline supply chains with real-time tracking, fleet management, & inventory control. Businesses stay organized & customers stay informed, every step of the way.",
            objectives: [
                "Track deliveries in real time.",
                "Manage fleets & inventories effortlessly.",
                "Keep operations running smoothly with smart solutions.",
            ],
            href: "/industries/logistics",
            tabImage: "logistics.avif"
        },
        {
            tabName: "Entertainment",
            tabDes:
                "Entertainment is about creating memorable experiences, & our web apps make that possible. Whether it’s streaming, gaming, or interactive content, we design solutions that captivate audiences & deliver seamless performance.",
            objectives: [
                "Build scalable platforms for streaming content.",
                "Engage users with interactive features.",
                "Deliver personalized entertainment experiences.",
            ],
            href: "/industries/entertainment",
            tabImage: "entertainment.avif"
        },
        {
            tabName: "Gaming",
            tabDes:
                "Gaming is about excitement, & our web apps take it to the next level. We build platforms that deliver immersive gameplay, real-time interactions, & scalable solutions for growing gaming communities.",
            objectives: [
                "Create multiplayer platforms with real-time features.",
                "Build tools for immersive & engaging experiences.",
                "Support growing user bases with scalable designs.",
            ],
            href: "/industries/gaming",
            tabImage: "gaming.png"
        },
        {
            tabName: "Social Networking",
            tabDes:
                "Connecting people is more important than ever, & our web apps make it easier. We create platforms for building communities, sharing content, & fostering meaningful interactions. Everything is designed to keep users engaged & connected.",
            objectives: [
                "Foster community building with interactive tools.",
                "Simplify multimedia sharing for users.",
                "Create platforms that grow with user needs.",
            ],
            href: "/industries/social-networking",
            tabImage: "social-networking.png"
        },
        {
            tabName: "Telecom",
            tabDes:
                "The telecom industry is all about staying connected, & our web apps help make it happen. From streamlining communication to managing customer services, we design solutions that keep telecom providers ahead in a fast-moving industry.",
            objectives: [
                "Manage networks & customer services efficiently.",
                "Provide secure systems for billing & data.",
                "Enhance communication tools for better user experiences.",
            ],
            href: "/industries/telecom",
            tabImage: "Telecom.png"
        },
        {
            tabName: "Energy",
            tabDes:
                "Energy management needs smarter solutions, & we deliver. Our web apps optimize resources, monitor usage, & support sustainability efforts. Whether it’s grid management or energy analytics, we help you run smoother & greener operations.",
            objectives: [
                "Monitor energy usage in real-time.",
                "Build scalable tools for grid management.",
                "Support sustainability with smart analytics.",
            ],
            href: "/industries/energy",
            tabImage: "Energy.png"
        },
    ]
}